/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeALeftIcon16Light = forwardRef('ArrowShapeALeftIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.427 8.883a1.25 1.25 0 0 1 0-1.768L7.293 1.25C7.923.619 9 1.065 9 1.956V4h4.5A1.5 1.5 0 0 1 15 5.5v5a1.5 1.5 0 0 1-1.5 1.5H9v2.042c0 .891-1.077 1.337-1.707.707L1.427 8.883Zm.707-1.06a.25.25 0 0 0 0 .353L8 14.042V11.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 1-.5-.5V1.956L2.134 7.822Z" })));
});
